import React from 'react';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="h-screen overflow-hidden bg-brand-dark text-white font-inter flex flex-col selection:bg-purple-500/30">
      {/* Global Background Effects */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-purple-600/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-blue-600/10 rounded-full blur-[120px]" />
      </div>

      <Header />
      
      <main className="flex-1 overflow-y-auto flex flex-col relative z-10 pt-20">
        {children}
      </main>

      <Footer />

      {/* Cache Buster / Version Tag */}
      <div className="fixed bottom-2 right-2 z-[9999] pointer-events-none opacity-30">
        <span className="text-[8px] font-mono text-white/50 bg-black/50 px-2 py-1 rounded-full backdrop-blur-sm border border-white/5">
          BUILD_TIME: {new Date().toISOString()}
        </span>
      </div>
    </div>
  );
};

export default Layout;
